import React, { useState, useEffect ,useRef} from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import classnames from "classnames";
import swal from "sweetalert";
import Config from "../../Config";
import moment from "moment";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { PersonalCategorysection } from "../qrcodemanagement/PersonalCategorysection";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js";
import {
  CheckQRCodeCategoriesManagementEnabled,
  CheckDynamicPersonalQRcodecount,
  CheckStaticPersonalQRcodecount,
} from "../../api/packageApi";
import QRCode from "qrcode.react";
import jsPDF from "jspdf";

function EditQRCode(props) {
  const location = useLocation();
  const [QrCodeID, setQrCodeID] = useState(location.state.QrcodeDetailsID);
  console.log("QrCodeID==>", QrCodeID);
  const [modal3, setmodal3] = useState(false);
  const [activeTab, setactiveTab] = useState("");
  const [activePill, setactivePill] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [CategoryIdError, setCategoryIdError] = useState("");
  const [subcategoryId, setsubcategoryId] = useState("");
  const [subcategoryIdError, setsubcategoryIdError] = useState("");
  const [CategoryList, setCategoryList] = useState([]);
  const [subcetgoryList, setsubcetgoryList] = useState([]);
  const [QrCodeTypeList, setQrCodeTypeList] = useState([]);
  const [WifiTypeList, setWifiTypeList] = useState([]);
  const [Static, setStatic] = useState(true);
  const [Dynamic, setDynamic] = useState(false);
  const [QRcodeName, setQRcodeName] = useState("");
  const [FinalQRcodeName, setFinalQRcodeName] = useState("");
  const [QRcodeNameQrcodesection, setQRcodeNameQrcodesection] = useState("");
  const [QRcodeNameError, setQRcodeNameError] = useState("");
  const [Websiteaddress, setWebsiteaddress] = useState("");
  const [WebsiteaddressError, setWebsiteaddressError] = useState("");
  const [description, setdescription] = useState("");
  const [descriptionError, setdescriptionError] = useState("");
  const [EventName, setEventName] = useState("");
  const [EventNameError, setEventNameError] = useState("");
  const [QrcodeLocation, setQrcodeLocation] = useState("");
  const [QrcodeLocationError, setQrcodeLocationError] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [startDateError, setStartDateError] = useState("");
  const [endDate, setEndDate] = useState(new Date());
  const [EndDateError, setEndDateError] = useState("");
  const [isstaticwifi_calender, setEndDateisstaticwifi_calender] =
    useState(true);
  const [WifiPassword, setWifiPassword] = useState("");
  const [WifiPasswordError, setWifiPasswordError] = useState("");
  const [WifiType, setWifiType] = useState("");
  const [WifiTypeName, setWifiTypeName] = useState("");
  const [WifiTypeError, setWifiTypeError] = useState("");
  const [ispasswordshow, setispasswordshow] = useState(false);
  const [Organization, setOrganization] = useState("");
  const [OrganizationError, setOrganizationError] = useState("");
  const [MyAddress, setMyAddress] = useState("");
  const [MyAddressError, setMyAddressError] = useState("");
  const [MyCity, setMyCity] = useState("");
  const [MyCityError, setMyCityError] = useState("");
  const [MyCountry, setMyCountry] = useState("");
  const [MyCountryName, setMyCounteryName] = useState("");
  const [MyCountryError, setMyCountryError] = useState("");
  const [MyStreet, setMyStreet] = useState("");
  const [MyStreetError, setMyStreetError] = useState("");
  const [MyHouseNo, setMyHouseNo] = useState("");
  const [MyHouseNoError, setMyHouseNoError] = useState("");
  const [MyPostCode, setMyPostCode] = useState("");
  const [MyPostCodeError, setMyPostCodeError] = useState("");
  const [MyEmail, setMyEmail] = useState("");
  const [MyEmailError, setMyEmailError] = useState("");
  const MINUTE_MS = 60000;
  //Email

  const [Emailsubject, setEmailsubject] = useState("");
  const [EmailsubjectError, setEmailsubjectError] = useState("");
  //Phone

  const [PhoneNumber, setPhoneNumber] = useState("");
  const [PhoneNumberError, setPhoneNumberError] = useState("");
  const [OfficePhoneNumberError, setOfficePhoneNumberError] = useState("");
  const [OfficePhoneNumber, setOfficePhoneNumber] = useState("");

  //cetgoryAdd
  const [MainCategoryError, setMainCategoryError] = useState("");
  const [MainCategory, setMainCategory] = useState("");
  const [subcategorylistnew, setsubcategorylistnew] = useState([]);
  const [SubCategoryAddtimeError, setSubCategoryAddtimeError] = useState("");
  const [isSubcategoryMaltiple, setisSubcategoryMaltiple] = useState(false);
  const [QrCodeString, setQrCodeString] = useState("");

  const [subToEmail, setsubToEmail] = useState([]);
  const [isToEamil, setisToEamil] = useState(false);
  const [ToemailEmptyError, setToemailEmptyError] = useState("");
  const [isToemailMaltiple, setisToemailMaltiple] = useState(false);
  const [CompanyLogoPath, setCompanyLogoPath] = useState("");
  const [MyQrcodeLogoPath, setMyQrcodeLogoPath] = useState("");
  const [MyQrcodeLogoPathID, setMyQrcodeLogoPathID] = useState("");
  const [CompanyLogo, setCompanyLogo] = useState(null);
  //Website Link
  const [websitelinkname, setwebsitelinkname] = useState("");
  const [websitelinknameError, setwebsitelinknameError] = useState("");
  const [WebLinkError, setWebLinkError] = useState("");
  const [webLink, setwebLink] = useState("");
  const [articleSegmentWebLinkList, setarticleSegmentWebLinkList] = useState(
    []
  );
  const [CountrydetailList, setCountrydetailList] = useState([]);

  const [PersonalData, setPersonalData] = useState(null);
  const domainFrontUrl = useRef("");
  useEffect(async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (checkLogin == "" || checkLogin == "" || checkLogin == undefined) {
      props.history.push("Login1");
    } else {
      await getDominUrl();
      await GetAllDropdwonArticle();
      await getAllQrCodeTypelist();
      await getAllWifiTypelist();
      await GetQrCodeDetalis(QrCodeID);
      getAllCountryDropdownlist();
    }
  }, []);

  const getDominUrl =async ()=>{
    let response = await GetDominUrl();
    if(response !== null && response.domainName !== null && response.domainName !== ""){
      domainFrontUrl.current = response.domainName;
    }
    else{
      domainFrontUrl.current="";
    }
}

  useEffect(() => {
    subcategorySet(CategoryId);
  }, [CategoryId]);

  const getAllCountryDropdownlist = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "GenericListing/DropdownList?categoryName=" + "Country",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        setCountrydetailList(result);
      });
    });
  };
  const GetAllDropdwonArticle = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let EmaptyArrry = [];
    await fetch(Config.apiUrl + "Category/CategoryListwithsubcategory", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then(async (resp1) => {
      resp1.json().then((result) => {
        if (result?.length > 0) {
          setCategoryList(result);
          //GetQrCodeDetalis(QrCodeID);
        } else {
          GetQrCodeDetalis(QrCodeID);
          setCategoryList(EmaptyArrry);
        }
        //GetQrCodeDetalis(QrCodeID);
      });
    });
  };
  const getAllQrCodeTypelist = async() => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "GenericListing/DropdownList?categoryName=QrCodeType",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setQrCodeTypeList(result);
        }
      });
    });
  };
  const getqrcodeAttributes = (PID) => {
    console.log("PID=>", PID);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (PID !== null && PID !== "" && PID !== undefined) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodestring?targetId=" +
        PID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          //Do something with the response
          if (responseJson !== null && responseJson !== "") {
            if (responseJson?.isCategoryStatic === false) {
              // setQrCodeString(Config.FrontUrl + responseJson?.codeString);
              let qrcodestring = domainFrontUrl.current + responseJson?.codeString;
              setQrCodeString(qrcodestring);
            }
            else{
              setQrCodeString(responseJson?.codeString);
            }
            setFinalQRcodeName(responseJson?.name);
          } else {
            setQrCodeString("");
            setFinalQRcodeName("");
          }
        })
        .catch((error) => {
          console.log(error);
          setQrCodeString("");
          setFinalQRcodeName("");
        });
    } else {
      setQrCodeString("");
    }
    //
  };
  const GetQrCodeDetalis = async (QrcodeIDobj) => {
    if (QrcodeIDobj != null && QrcodeIDobj != "" && QrcodeIDobj != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let EmaptyArrry = [];
      await fetch(
        Config.apiUrl + "QrCodeResourceController/ById?id=" + QrcodeIDobj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then(async (resp1) => {
        resp1.json().then((result) => {
          console.log("Result=>", result);
          getqrcodeAttributes(QrcodeIDobj);
          //
          setPersonalData(result);
          //subcategorySet(result.categoryID);
          if (
            result?.imagePath !== null &&
            result?.imagePath !== "" &&
            result?.imagePath !== undefined
          ) {
            setMyQrcodeLogoPath(Config.contentUrl + result.imagePath);
            setMyQrcodeLogoPathID(result.image_id);
          } else {
            setMyQrcodeLogoPath("");
            setMyQrcodeLogoPathID("");
          }
          
          // setCompanyLogoPath(result.imagePath)
          setactiveTab(result.qrCodeType);
          setactivePill(result.qrCodeType);
          setQRcodeName(result.name);
          setQRcodeNameQrcodesection(result.name);

          setdescription(result.desctiption);
          setEmailsubject(result.subject);
          setWebsiteaddress(result.website);
          setPhoneNumber(result.phoneNo);
          setMyCity(result.city);
          setMyStreet(result.street);
          setMyPostCode(result.postcode);
          setOfficePhoneNumber(result.officeNo);
          setMyCountry(result.countryId);
          setWifiTypeName(result?.wifiTypeDetail?.name);
          setMyHouseNo(result.houseNo);
          setMyCounteryName(result?.countryDetail?.name);
          setarticleSegmentWebLinkList(result?.externalLink);
          if (result.isCategoryStatic === false) {
            setDynamic(true);
            setStatic(false);
          }
          setCategoryId(result.categoryID);

          //setEventName(result.name);
          setQrcodeLocation(result.location);
          if (
            result.startDate != null &&
            result.startDate != "" &&
            result.startDate != undefined
          ) {
            let startDatetemp = moment(result.startDate).toDate();
            setStartDate(startDatetemp);
          }
          if (
            result.endDate != null &&
            result.endDate != "" &&
            result.startDate != undefined
          ) {
            let EndDatetemp = moment(result.endDate).toDate();
            setEndDate(EndDatetemp);
          }
          //setStartDate(result.startDate);

          setWifiType(result.wifiType);
          setWifiPassword(result.password);
          setOrganization(result.organization);
          setMyAddress(result.address);
          setMyEmail(result.email);
          setEndDateisstaticwifi_calender(result.isStatic);
          //setispasswordshow(result.isStatic);
          setispasswordshow(result?.isPasswordShow);

          setsubcategoryId(result.subCategoryID);
        });
      });
    }
  };
  const getAllWifiTypelist = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "GenericListing/DropdownList?categoryName=WifiType", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setWifiTypeList(result);
        }
      });
    });
  };
  const toggle3 = () => {
    setsubcategorylistnew([""]);
    setMainCategory("");
    setmodal3(!modal3);
  };
  const togglePill = (pill) => {
    if (activePill !== pill) {
      setQRcodeName("");
      setQRcodeNameError("");
      setCategoryId("");
      setCategoryIdError("");
      setsubcetgoryList([]);
      setsubcategoryId("");
      setsubcategoryIdError("");
      setdescription("");
      setdescriptionError("");
      setEmailsubjectError("");
      setEmailsubject("");
      setWebsiteaddress("");
      setWebsiteaddressError("");
      setPhoneNumber("");
      setPhoneNumberError("");
      setOfficePhoneNumber("");
      setOfficePhoneNumberError("");
      setStatic(true);
      setDynamic(false);
      //setEventName('');
      setQrcodeLocation("");
      setStartDate(new Date());
      setEndDate(new Date());
      setStartDateError("");
      setEndDateError("");
      setQrcodeLocation("");
      setQrcodeLocationError("");
      //setEventNameError('');
      setWifiPasswordError("");
      setWifiTypeError("");
      setWifiType("");
      setWifiPassword("");
      setOrganization("");
      setOrganizationError("");
      setMyAddress("");
      setMyAddressError("");
      setMyStreet("");
      setMyCity("");
      setMyCountry("");
      setMyHouseNo("");
      setMyPostCode("");
      setMyStreetError("");
      setMyCityError("");
      setMyCountryError("");
      setMyCounteryName("");
      setWifiTypeName("");
      setMyHouseNoError("");
      setMyPostCodeError("");
      setCompanyLogoPath("");
      setWebLinkError("");
      setwebsitelinkname("");
      setwebLink("");
      setwebsitelinknameError("");
      setarticleSegmentWebLinkList("");
      setMyEmail("");
      setMyEmailError("");
      setEndDateisstaticwifi_calender(true);
      setactivePill(pill);
    }
  };
  const onChangeCategory = (event) => {
    setCategoryId(event.target.value);
    setCategoryIdError("");
    setsubcetgoryList([]);
  };
  const subcategorySet = (catID) => {
    var subCategoryDetailList = CategoryList.find((x) => x._id === catID);
    if (subCategoryDetailList != undefined) {
      setsubcetgoryList(subCategoryDetailList.subCategoryModelList);
      setsubcategoryId("");
    } else {
      setsubcetgoryList([]);
      setCategoryId("");
      setsubcategoryId("");
    }
  };

  const onChangeSubCategory = (event) => {
    setsubcategoryId(event.target.value);
    setsubcategoryIdError("");
  };
  const onchangeStaticCheckbox = (e) => {
    let ischeck = e.target.checked;
    if (ischeck === true) {
      setDynamic(false);
      setStatic(ischeck);
    }
  };
  const onchangewifi_calenderStaticCheckbox = (e) => {
    setEndDateisstaticwifi_calender(e.target.checked);
  };
  const onchangeDynamicCheckbox = (e) => {
    let ischeck = e.target.checked;
    if (ischeck === true) {
      setDynamic(ischeck);
      setStatic(false);
    }
  };
  const onChangeMaincategory = (event) => {
    setMainCategoryError("");
    setMainCategory(event.target.value);
  };
  const SubCategoryaddClick = (e) => {
    setsubcategorylistnew((n) => [...n, ""]);
  };
  const createSubCategoryUI = () => {
    return subcategorylistnew.map((el, i) => (
      <>
        <div key={i} className="removeSection">
          <input
            maxLength={30}
            type="text"
            className="form-control col-sm-8"
            placeholder="Please Enter Sub Category"
            value={el || ""}
            // onChange={(e) => { SubCategoryhandleChange(i, e) }} />
            onChange={SubCategoryhandleChange(i)}
          />
          {i > 0 ? (
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                SubCategoryremoveClick(i);
              }}
              className="btn btn-danger ml-2"
            >
              <i class="fas fa-trash"></i>
            </a>
          ) : (
            ""
          )}
        </div>
        <p
          class="col-sm-8"
          style={{ textAlign: "right", fontSize: 12, color: "red" }}
        >
          {el.length}/30
        </p>
      </>
    ));
  };
  const SubCategoryhandleChange = (i) => (event) => {
    setSubCategoryAddtimeError("");
    let subcategorylistnewTemp = [...subcategorylistnew];
    subcategorylistnewTemp[i] = event.target.value;
    setsubcategorylistnew(subcategorylistnewTemp);
    //console.log(subcategorylistnew);

    const unique = [...new Set(subcategorylistnewTemp)];
    if (subcategorylistnewTemp?.length === unique?.length) {
      setisSubcategoryMaltiple(false);
    } else {
      setisSubcategoryMaltiple(true);
    }
  };
  const SubCategoryremoveClick = (i) => {
    let subcategorylistnewTemp = [...subcategorylistnew];
    subcategorylistnewTemp.splice(i, 1);
    setsubcategorylistnew(subcategorylistnewTemp);
  };
  const onChangeWifiType = (event) => {
    setWifiTypeError("");
    setWifiType(event.target.value);
    if (WifiTypeList?.length > 0) {
      WifiTypeList.map((item) => {
        if (item.value === event.target.value) {
          if (item.text === "No Password") {
            setWifiPassword("");
          }
          setWifiTypeName(item.text);
        }
      });
    }
  };
  const onchangeQRcodeName = (event) => {
    setQRcodeNameError("");
    setQRcodeName(event.target.value);
  };
  const onchangeWifiPassword = (event) => {
    setWifiPasswordError("");
    setWifiPassword(event.target.value);
  };

  const onchangeQRcodeWebAddress = (event) => {
    setWebsiteaddressError("");
    if (
      !new RegExp("(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?").test(
        event.target.value
      )
    ) {
      setWebsiteaddressError("Invalid");
      setWebsiteaddress(event.target.value);
    } else {
      setWebsiteaddress(event.target.value);
    }
  };
  const onChangeDescription = (event) => {
    setdescriptionError("");
    if (event.target.value >= 600) {
      setdescriptionError(
        "You have reached your maximum limit of characters allowed"
      );
    } else {
      setdescription(event.target.value);
    }
  };
  const onchangeEmailSubject = (event) => {
    setEmailsubject(event.target.value);
    setEmailsubjectError("");
  };
  const onchangePhoneName = (event) => {
    setPhoneNumberError("");
    setPhoneNumber(event.target.value.replace(/[^\d+]/, ""));
    //setPhoneNumber(event);
  };
  const onchangeOfficePhoneName = (event) => {
    setOfficePhoneNumber(event.target.value.replace(/[^\d+]/, ""));
    setOfficePhoneNumberError("");
  };
  // const onchangeEvenet = (event) => {
  //     setEventNameError('');
  //     setEventName(event.target.value);
  // }
  const onchangeLoction = (event) => {
    setQrcodeLocationError("");
    setQrcodeLocation(event.target.value);
  };
  const onChangeStartDate = (event) => {
    setStartDateError("");
    setStartDate(event);
  };
  const onChangeEndDate = (event) => {
    setEndDateError("");
    setEndDate(event);
  };
  const Onclickpasseordshow = () => {
    setispasswordshow(!ispasswordshow);
  };
  const onchangeOrganization = (event) => {
    setOrganization(event.target.value);
    setOrganizationError("");
  };
  const onchangeMyStreet = (event) => {
    setMyStreet(event.target.value);
    setMyStreetError("");
  };
  const onchangeMyPostCode = (event) => {
    setMyPostCode(event.target.value);
    setMyPostCodeError("");
  };
  const onchangeMyHouseNo = (event) => {
    setMyHouseNo(event.target.value);
    setMyHouseNoError("");
  };
  const onchangeMyCity = (event) => {
    setMyCity(event.target.value);
    setMyCityError("");
  };
  const onchangeMyCountry = (event) => {
    console.log("event.target.value=>", event.target.value);
    setMyCountryError("");
    setMyCountry(event.target.value);
    if (CountrydetailList?.length > 0) {
      CountrydetailList.map((item) => {
        if (item.value === event.target.value) {
          setMyCounteryName(item.text);
        }
      });
    }
  };
  const onChangewebsitelinkname = (event) => {
    setwebsitelinknameError("");
    setwebsitelinkname(event.target.value);
  };
  const onChangeWebLink = (event) => {
    setWebLinkError("");
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      event.target.value !== undefined
    ) {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(event.target.value)
      ) {
        setWebLinkError("Invalid weblink");
        setwebLink(event.target.value);
      } else {
        setwebLink(event.target.value);
      }
    } else {
      setwebLink(event.target.value);
    }

    // setwebLink(event.target.value);
  };
  const CompanysetFile = (event) => {
    // var filesize = ((event.target.files[0].size/1024)/1024).toFixed(4)
    setCompanyLogoPath(URL.createObjectURL(event.target.files[0]));
    setCompanyLogo(event.target.files[0]);
  };

  const deletemyImage = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      _idFileUplod !== null &&
      _idFileUplod !== "" &&
      _idFileUplod !== undefined &&
      _idFileUplod !== "undefined"
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                setCompanyLogoPath("");
                setCompanyLogo(null);
                setMyQrcodeLogoPathID();
                setMyQrcodeLogoPath("");
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Images is safe!");
              }
            });
          });
        }
      });
    }
  };
  const onchangeMyAddress = (event) => {
    setMyAddress(event.target.value);
    setMyAddressError("");
  };
 
  const onchangeMyEmail = (event) => {
    setMyEmailError("");
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(event.target.value)) {
      setMyEmail(event.target.value);
      setMyEmailError("Please enter valid email");
    } else {
      setMyEmailError("");
      setMyEmail(event.target.value);
    }
  };
  const UpdateQRCode = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    let QrCodTypename = activePill;

    if (QRcodeName === null || QRcodeName === "" || QRcodeName === undefined) {
      retval = false;
      setQRcodeNameError("Enter Qrcode name");
    }
    if (QrCodTypename === "URL") {
      if (
        Websiteaddress === null ||
        Websiteaddress === "" ||
        Websiteaddress === undefined
      ) {
        retval = false;
        setWebsiteaddressError("Enter Website address ");
      }
      if (
        WebsiteaddressError !== null &&
        WebsiteaddressError !== "" &&
        WebsiteaddressError !== undefined
      ) {
        retval = false;
        setWebsiteaddressError("invalid");
      }
    }
    if (QrCodTypename === "Text") {
      if (
        description === null ||
        description === "" ||
        description === undefined
      ) {
        retval = false;
        setdescriptionError("Enter description");
      }
    }
    if (QrCodTypename === "Email") {
      
      if (
        description === null ||
        description === "" ||
        description === undefined
      ) {
        retval = false;
        setdescriptionError("Enter body description");
      }
    }
    if (QrCodTypename === "Phone") {
      if (
        PhoneNumber === null ||
        PhoneNumber === "" ||
        PhoneNumber === undefined
      ) {
        retval = false;
        setPhoneNumberError("Enter PhoneNumber");
      }
      if (
        PhoneNumberError !== null &&
        PhoneNumberError !== undefined &&
        PhoneNumberError !== ""
      ) {
        retval = false;
        setPhoneNumberError(PhoneNumberError);
      }
    }
    
    if (QrCodTypename === "Calendar") {
      if (
        Emailsubject === null ||
        Emailsubject === "" ||
        Emailsubject === undefined
      ) {
        retval = false;
        setEmailsubjectError("Enter Event Name");
      }
      
      if (
        startDate != null &&
        startDate != "" &&
        startDate != undefined &&
        startDate != null &&
        endDate != "" &&
        endDate != undefined
      ) {
        if (Date.parse(startDate) > Date.parse(endDate)) {
          retval = false;
          setEndDateError("End date should be greater than Start date");
        }
      }
    }
    if (QrCodTypename === "Wifi") {
      
      if (WifiType === null || WifiType === "" || WifiType === undefined) {
        retval = false;
        setWifiTypeError("select WifiType");
      }
      if (
        Emailsubject === null ||
        Emailsubject === "" ||
        Emailsubject === undefined
      ) {
        retval = false;
        setEmailsubjectError("Enter SSID/Network name");
      }
    }
    if (QrCodTypename === "MyQR") {
      
      if (
        Emailsubject === null ||
        Emailsubject === "" ||
        Emailsubject === undefined
      ) {
        retval = false;
        setEmailsubjectError("Enter Name");
      }
     
      if (MyEmail !== null && MyEmail !== "" && MyEmail !== undefined) {
        if (
          MyEmailError !== null &&
          MyEmailError !== undefined &&
          MyEmailError !== ""
        ) {
          retval = false;
          setMyEmailError(MyEmailError);
        }
      }
      
    }

    if (retval === true) {
      var data = {
        _id: QrCodeID,
        UserCompanyID: loginid,
        QrCodeType: activePill,
        TargetType: "personalqrcode",
        Name: QRcodeName,
        Website: Websiteaddress,
        Desctiption: description,
        Subject: Emailsubject,
        CategoryID: CategoryId,
        SubCategoryID: subcategoryId,
        IsCategoryStatic: Static,
        PhoneNo: PhoneNumber,
        //TargetID: "0",
        StartDate: startDate,
        EndDate: endDate,
        Location: QrcodeLocation,
        isStatic: ispasswordshow,
        Password: WifiPassword,
        WifiType: WifiType,
        Organization: Organization,
        OfficeNo: OfficePhoneNumber,
        City: MyCity,
        CountryId: MyCountry,
        HouseNo: MyHouseNo,
        Street: MyStreet,
        PostCode: MyPostCode,
        // Address: MyAddress,
        Email: MyEmail,
        IsPublished: true,
        ExternalLink: articleSegmentWebLinkList,
        IsPasswordShow: ispasswordshow,
      };
      console.log("UpdatePersonlQrCode===>", data);
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdatePersonalQrcode?id=" +
        QrCodeID,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }
      )
        .then((result1) => {
          result1.json().then(async (resp) => {
            if (resp != null) {
              fileUploadLablePost(resp._id);
              await Qrcodestringadd(resp._id);
             
              swal("update", "Your qrcode details are Update.", "success");
            } else {
              swal("Sorry!", "Your qrcode details are not Update.", "error");
            }
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  };
  const fileUploadLablePost = async (LabelIDObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = await localStorage.getItem("UserCompanyId");
    if (CompanyLogo != null) {
      const byte = CompanyLogo?.size;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            const formData = new FormData();
            formData.append("body", CompanyLogo);
            formData.append("fileType", "MyQrCodeImage");
            formData.append("targetId", LabelIDObj);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");

            fetch(Config.apiUrl + "FileUpload/Update?id=" + "", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "PUT",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                console.log(resp);
                // Qrcodestringadd(LabelIDObj)
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    }
  };
  const Qrcodestringadd =async (PID) => {
    // let url = Config.FrontUrl + 'PersonalQrCodedetails?mapId=' + PID;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let url = "";
    if (Static === true) {
      if (activePill === "URL") {
        if (Websiteaddress.slice(0, 4) === "http") {
          // Linking.openURL(Url);
          url = Websiteaddress;
        } else {
          // Linking.openURL("https://" + Url)
          url = "https://" + Websiteaddress;
        }
      } else if (activePill === "Text") {
        url = description;
        // setQrCodeString(url)
      } else if (activePill === "Phone") {
        url = `tel:${PhoneNumber}`;
        // setQrCodeString(url)
      } else if (activePill === "SMS") {
        url = `sms:${PhoneNumber}?body=${description}`;
        // setQrCodeString(url)
      } else if (activePill === "Wifi") {
        url = `WIFI:T:${WifiTypeName};S:${Emailsubject};P:${WifiPassword};H:${ispasswordshow};`;
        // setQrCodeString(url)
      } else if (activePill === "Email") {
        // url = `MATMSG:TO:${MyEmail};SUB:${Emailsubject};BODY:${description};;`
        url = `mailto:${MyEmail}?subject=${Emailsubject}&body=${description}`;
        // setQrCodeString(url)
      } else if (activePill === "Calendar") {
        const dateStartFormatted = moment(startDate).format("YYYYMMDD");
        const dateEndFormatted = moment(endDate).format("YYYYMMDD");
        url = `BEGIN:VCALENDAR\nBEGIN:VEVENT\nDTSTART:${dateStartFormatted}\nDTEND:${dateEndFormatted}\nSUMMARY:${Emailsubject}\nLOCATION:${QrcodeLocation}\nDESCRIPTION:${description}\nEND:VEVENT\nEND:VCALENDAR;;`;

      } else if (activePill === "MyQR") {
        url = `BEGIN:VCARD\nVERSION:3.0\nN:${Emailsubject}\nORG:${Organization}\nEMAIL;TYPE=INTERNET:${MyEmail}\nURL:${articleSegmentWebLinkList?.map(
          (item) => item.linkURL,
          "\n"
        )}\nTEL;TYPE=CELL:${PhoneNumber}\nTEL:${OfficePhoneNumber}\nTEL;TYPE=FAX:\nADR:;;${MyStreet};${MyCity};${MyHouseNo};${MyPostCode};${MyCountryName}\nEND:VCARD`;
        // url = `BEGIN:VCARD\nVERSION:3.0\nN:${Emailsubject}\nORG:${Organization}\nTITLE:${Emailsubject}\nEMAIL;TYPE=INTERNET:${MyEmail}\nURL:${articleSegmentWebLinkList?.map((item) => item.linkURL, "\n")}\nTEL;TYPE=CELL:${PhoneNumber}\nTEL:${OfficePhoneNumber}\nTEL;TYPE=FAX:\nADR:;;${MyStreet};${MyCity};${MyHouseNo};${MyPostCode};${MyCountryName}\nEND:VCARD`

      }
    } else {
      url =
        Config.FrontUrl +
        "PersonalQrCodedetails?mapId=" +
        PID +
        "&render=details&maptarget=personal";
    }
    let ArticleQrcodestring = {
      _id: PID,
      UserCompanyID: loginid,
      TargetID: PID,
      CodeString: url,
      IsDeleted: false,
    };
    fetch(
      Config.apiUrl + "QrCodeResourceController/UpdateQrcodestring?id=" + PID,
      {
        headers: {
          userCompanyID: loginid,
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        method: "PUT",
        body: JSON.stringify(ArticleQrcodestring),
      }
    )
      .then((result) => {
        result.json().then((resp) => {
          if (resp !== null) {
            getqrcodeAttributes(PID);
            // swal("successfully", "  Personal QrCode generate.", "success");
          } else {
            // swal("error", "Personal Qrcode not generate.", "error");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const createCategory = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      MainCategory === null ||
      MainCategory === "" ||
      MainCategory === undefined
    ) {
      retval = false;
      setMainCategoryError("Category name must be filled out ");
    }
    if (subcategorylistnew?.length === 0) {
      setSubCategoryAddtimeError("sub Category name must be filled out");
    } else {
      const found = subcategorylistnew.find(
        (element) => element === "" || element === "" || element === null
      );
      if (found != undefined) {
        setSubCategoryAddtimeError("Sub Category Name must be filled out");
        retval = false;
      }

      const unique = [...new Set(subcategorylistnew)];
      if (subcategorylistnew?.length !== unique?.length) {
        retval = false;
      }
    }
    if (retval === true) {
      fetch(
        Config.apiUrl +
        "Category/CheckCategory?id=" +
        "" +
        "&categoryName=" +
        MainCategory,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            var data = {
              Name: MainCategory,
              SubCategoryList: subcategorylistnew,
              UserCompanyID: loginid,
              ParentID: "0",
            };
            fetch(Config.apiUrl + "Category/CreateCategory", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(data),
            })
              .then((result1) => {
                result1.json().then((resp) => {
                  if (resp != null) {
                    toggle3();
                    GetAllDropdwonArticle();
                    //setCategoryId(resp._id);
                  }
                });
              })
              .catch((error) => {
                console.error("There was an error!", error);
              });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    }
  };
  const CreateExternalLink = () => {
    let IsValid = true;
    console.log("articleSegmentWebLinkList==>", articleSegmentWebLinkList);
    var WebLinklData = [...articleSegmentWebLinkList];
    if (webLink === "" || webLink === undefined || webLink === null) {
      IsValid = false;
      setWebLinkError("webLink must be filled out");
    } else {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(webLink)
      ) {
        setWebLinkError("Invalid weblink");
        IsValid = false;
      }
      if (WebLinkError?.length > 0) {
        IsValid = false;
        setWebLinkError(WebLinkError);
      }
    }
    if (IsValid === true) {
      var data = {
        name: websitelinkname,
        linkURL: webLink,
      };
      WebLinklData.push(data);
      console.log("WebLinklData=>", WebLinklData);
      setarticleSegmentWebLinkList(WebLinklData);
      setwebLink("");
      setwebsitelinkname("");
    }
  };

  const ArticleWeblinkdelete = (index) => {
    let articleSegmentWebLinkListTemp = [...articleSegmentWebLinkList];
    articleSegmentWebLinkListTemp.splice(index, 1);
    setarticleSegmentWebLinkList(articleSegmentWebLinkListTemp);
  };
  const downloadQRCodeArticle = (type) => {
    let QrcodeID = "";
    if (type === "URL") {
      QrcodeID = "qrCodeElURL";
    } else if (type === "Text") {
      QrcodeID = "qrCodeElText";
    } else if (type === "Email") {
      QrcodeID = "qrCodeElEmail";
    } else if (type === "Phone") {
      QrcodeID = "qrCodeElPhone";
    } else if (type === "SMS") {
      QrcodeID = "qrCodeElSMS";
    } else if (type === "Calendar") {
      QrcodeID = "qrCodeElCalendar";
    } else if (type === "Wifi") {
      QrcodeID = "qrCodeElWifi";
    } else if (type === "MyQR") {
      QrcodeID = "qrCodeElMyQR";
    }
    // const qrCodeURL = document.getElementById(QrcodeID)
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // var doc = new jsPDF("p", "pt", "c6");
    // doc.setFontSize(22);
    // doc.text(20, 30, "Qr Code");
    // doc.setFontSize(10);
    // // doc.text(20, 80, "Title: " + row.title);
    // // doc.text(20, 100, "Years: " + row.years);
    // doc.addImage(qrCodeURL, "JPEG", 100, 100, 150, 200);
    // doc.save("QrCode.pdf");

    const qrCodeURL = document
      .getElementById(QrcodeID)
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const printQrcode = (type) => {
    let QrcodeID = "";
    if (type === "URL") {
      QrcodeID = "qrCodeElURL";
    } else if (type === "Text") {
      QrcodeID = "qrCodeElText";
    } else if (type === "Email") {
      QrcodeID = "qrCodeElEmail";
    } else if (type === "Phone") {
      QrcodeID = "qrCodeElPhone";
    } else if (type === "SMS") {
      QrcodeID = "qrCodeElSMS";
    } else if (type === "Calendar") {
      QrcodeID = "qrCodeElCalendar";
    } else if (type === "Wifi") {
      QrcodeID = "qrCodeElWifi";
    } else if (type === "MyQR") {
      QrcodeID = "qrCodeElMyQR";
    }
    const qrCodeURL = document
      .getElementById(QrcodeID)
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "c6");
    doc.setFontSize(22);
    doc.text(20, 30, FinalQRcodeName);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };

  const toggleToEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamil(!isToEamil);
  };

  const SubToEmailremoveClick = (i) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToEmailTemp = [...subToEmail];
    if (subToEmailTemp != null && subToEmailTemp !== undefined) {
      subToEmailTemp.splice(i, 1);
    }
    setsubToEmail(subToEmailTemp);
  };
  const SubToEmailhandleChange = (i) => (event) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToemaillistnewTemp = [...subToEmail];
    subToemaillistnewTemp[i] = event.target.value;
    setsubToEmail(subToemaillistnewTemp);
    const unique = [...new Set(subToemaillistnewTemp)];
    if (subToemaillistnewTemp?.length !== unique?.length) {
      setisToemailMaltiple(true);
    }
  };
  const SubToEmailaddClick = () => {
    setsubToEmail((n) => [...n, ""]);
  };
  const createSubToEmailUI = () => {
    return subToEmail.map((el, i) => (
      <div key={i} className="removeSection">
        <input
          type="text"
          className="form-control mr-2"
          //maxlength="50"
          placeholder="Enter To Email"
          value={el || ""}
          onChange={SubToEmailhandleChange(i)}
        />
        {i > 0 ? (
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              SubToEmailremoveClick(i);
            }}
            className="btn btn-danger"
          >
            <i class="fas fa-trash"></i>
          </a>
        ) : (
          <></>
        )}
      </div>
    ));
  };

  const QRCodePersonalSend = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail?.length !== unique?.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }

    let QrcodeID = "";
    if (activePill === "URL") {
      QrcodeID = "qrCodeElURL";
    } else if (activePill === "Text") {
      QrcodeID = "qrCodeElText";
    } else if (activePill === "Email") {
      QrcodeID = "qrCodeElEmail";
    } else if (activePill === "Phone") {
      QrcodeID = "qrCodeElPhone";
    } else if (activePill === "SMS") {
      QrcodeID = "qrCodeElSMS";
    } else if (activePill === "Calendar") {
      QrcodeID = "qrCodeElCalendar";
    } else if (activePill === "Wifi") {
      QrcodeID = "qrCodeElWifi";
    } else if (activePill === "MyQR") {
      QrcodeID = "qrCodeElMyQR";
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById(QrcodeID)
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: activePill + "/" + QRcodeName,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmail();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };
  return (
    <>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/home">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/qrcodemanagement/ProductQRCode/productqrcode">
              QR Code management{" "}
            </Link>
          </li>
          <li className="breadcrumb-item active">Personal QR Code</li>
        </ol>
        <h1 className="page-header">Personal QR Code </h1>
        <Panel>
          <PanelHeader>
            <h4 className="mb-0 text-white">Edit personal QR codes</h4>
          </PanelHeader>
          <PanelBody>
            <Nav className="mb-3" pills>
              {QrCodeTypeList?.length > 0 ? (
                QrCodeTypeList.map((item) => (
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activePill === item.text,
                      })}
                      onClick={() => {
                        togglePill(item.text);
                      }}
                      disabled
                    >
                      <span className="d-sm-none">{item.text}</span>
                      <span className="d-sm-block d-none">{item.text}</span>
                    </NavLink>
                  </NavItem>
                ))
              ) : (
                <></>
              )}
            </Nav>
            <TabContent
              className="p-15 rounded bg-white mb-4"
              activeTab={activePill}
            >
              <TabPane tabId="URL">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i className="ion ion-md-link fa-2x fa-fw pull-left m-r-5 text-white"></i>
                            <h5 className="mb-0 text-white">URL</h5>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                maxLength={60}
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                //autocomplete="off"
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName.length}/60
                              </p>
                              {QRcodeNameError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Enter website address below
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter website address"
                                value={Websiteaddress}
                                //autocomplete="new-email"
                                onChange={(e) => {
                                  onchangeQRcodeWebAddress(e);
                                }}
                              />
                              {WebsiteaddressError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {WebsiteaddressError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <button type="submit" className="btn btn-primary shadow-add m-r-10">Save</button>
                                                <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          {/* <h2>URL</h2> */}
                          <div className="row  justify-content-center">
                            <div className=" bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">URL</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElURL"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}

                          <h3>{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("URL");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("URL");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}

                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="Text">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        {/* <div className="d-flex align-items-center">
                                                    <i className="fa fa-text-width m-r-15 fa-2x fa-fw "></i>
                                                    <h5 className="mb-10">Text</h5>
                                                </div> */}
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i className="fa fa-text-width m-r-15 fa-2x fa-fw text-white"></i>
                            <h5 className="mb-0 text-white">Text</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                maxLength={60}
                                autocomplete="off"
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName.length}/60
                              </p>
                              {QRcodeNameError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="col-form-label ">
                                Write the Text below
                              </label>
                             
                              <textarea
                                className="form-control "
                                value={description}
                                maxLength={600}
                                rows="3"
                                placeholder="Enter Text"
                                onChange={onChangeDescription}
                              ></textarea>
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {description.length}/600
                              </p>
                              {descriptionError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {descriptionError}
                                </span>
                              )}
                              {/* <textarea className="form-control " rows="3" placeholder='Enter text'></textarea> */}
                            </div>
                          </div>
                        </div>
                        {/* <button type="submit" className="btn btn-primary shadow-add m-r-10">Save</button>
                                                <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center">
                            <div className="  bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">Text</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElText"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}
                          {/* <img src="../assets/img/user/QR.png" alt='img' style={{ minHeight: '200px', maxHeight: '300px', }}></img> */}
                          <h3>{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("Text");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("Text");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="Email">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i className="ion ion-md-mail fa-2x fa-fw pull-left m-r-10 text-white"></i>
                            <h5 className="mb-0 text-white">Email</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                maxLength={60}
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                //autocomplete="off"
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {QRcodeNameError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Email address
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                maxLength={60}
                                placeholder="Enter Email address"
                                value={MyEmail}
                                //autocomplete="new-email"
                                onChange={(e) => {
                                  onchangeMyEmail(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {MyEmailError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {MyEmailError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Enter Subject
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                maxLength={60}
                                placeholder="Enter Subject"
                                value={Emailsubject}
                                onChange={(e) => {
                                  onchangeEmailSubject(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {Emailsubject?.length}/60
                              </p>
                              {EmailsubjectError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {EmailsubjectError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="col-form-label">Body</label>
                              <textarea
                                className="form-control "
                                value={description}
                                maxLength={600}
                                rows="3"
                                placeholder="Enter Body"
                                onChange={onChangeDescription}
                              ></textarea>
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {description?.length}/600
                              </p>
                              {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={description}
                                                                onReady={editor => {
                                                                    // You can store the "editor" and use when it is needed.
                                                                    console.log('Editor is ready to use!', editor);
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    onChangeDescription(data);
                                                                    //console.log({ event, editor, data });
                                                                }}
                                                                onBlur={(event, editor) => {
                                                                    console.log('Blur.', editor);
                                                                }}
                                                                onFocus={(event, editor) => {
                                                                    console.log('Focus.', editor);
                                                                }}
                                                                style={{ height: 200 }}
                                                            /> */}
                              {descriptionError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {descriptionError}
                                </span>
                              )}
                              {/* <textarea placeholder='Enter' className="form-control" rows="3"></textarea> */}
                            </div>
                          </div>
                        </div>
                        {/* <button type="submit" className="btn btn-primary shadow-add m-r-10">Save</button>
                                                <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center">
                            <div className=" bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">Email</h3>
                            </div>
                          </div>
                          {/* <img src="../assets/img/user/QR.png" alt='img' style={{ minHeight: '200px', maxHeight: '300px', }}></img> */}
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElEmail"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}

                          <h3>{FinalQRcodeName}</h3>

                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("Email");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("Email");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="Phone">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i className="ion ion-md-call fa-2x fa-fw pull-left m-r-10 text-white"></i>
                            <h5 className="mb-0 text-white">Phone</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                maxLength={60}
                                //autocomplete="off"
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {QRcodeNameError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Enter the phone number to call below
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Number"
                                value={PhoneNumber}
                                //maxLength={13}
                                //autocomplete="off"
                                onChange={(e) => {
                                  onchangePhoneName(e);
                                }}
                              />
                              {/* <PhoneInput
                                id="exampleInputEmail1"
                                flags={flags}
                                className="form-control input-design-1"
                                placeholder="Enter Number"
                                value={PhoneNumber}
                                onChange={onchangePhoneName}
                              /> */}
                              {PhoneNumberError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {PhoneNumberError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <button type="submit" className="btn btn-primary shadow-add m-r-10">Save</button>
                                                <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center">
                            <div className=" bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">Phone</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElPhone"
                              sclassName="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}
                          {/* <img src="../assets/img/user/QR.png" alt='img' style={{ minHeight: '200px', maxHeight: '600px', }}></img> */}

                          <h3>{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("Phone");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("Phone");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="SMS">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i className="ion ion-md-text fa-2x fa-fw pull-left m-r-10 text-white"></i>
                            <h5 className="mb-0 text-white">SMS</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                maxLength={60}
                                //autocomplete="off"
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {QRcodeNameError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Enter Number below
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Number"
                                value={PhoneNumber}
                                maxLength={13}
                                //autocomplete="off"
                                onChange={(e) => {
                                  onchangePhoneName(e);
                                }}
                              />
                              {PhoneNumberError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {PhoneNumberError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="col-form-label">
                                Write the Text below
                              </label>
                              {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={description}
                                                                onReady={editor => {
                                                                    // You can store the "editor" and use when it is needed.
                                                                    console.log('Editor is ready to use!', editor);
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    onChangeDescription(data);
                                                                    //console.log({ event, editor, data });
                                                                }}
                                                                onBlur={(event, editor) => {
                                                                    console.log('Blur.', editor);
                                                                }}
                                                                onFocus={(event, editor) => {
                                                                    console.log('Focus.', editor);
                                                                }}
                                                                style={{ height: 200 }}
                                                            /> */}
                              <textarea
                                className="form-control "
                                value={description}
                                maxLength={600}
                                rows="3"
                                placeholder="Enter Text"
                                onChange={onChangeDescription}
                              ></textarea>
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {description?.length}/600
                              </p>
                              {descriptionError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {descriptionError}
                                </span>
                              )}
                              {/* <textarea placeholder='Enter text' className="form-control" rows="3"></textarea> */}
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center">
                            <div className="  bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">SMS</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElSMS"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}
                          {/* <img src="../assets/img/user/QR.png" alt='img' style={{ minHeight: '200px', maxHeight: '300px', }}></img> */}
                          <h3>{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("SMS");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("SMS");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="Calendar">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i className="ion ion-md-calendar fa-2x fa-fw pull-left m-r-10 text-white"></i>
                            <h5 className="mb-0 text-white">Calendar</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                //autocomplete="off"
                                maxLength={60}
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {QRcodeNameError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Event Name
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Event Name"
                                maxLength={100}
                                value={Emailsubject}
                                onChange={(e) => {
                                  onchangeEmailSubject(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {Emailsubject?.length}/100
                              </p>
                              {EmailsubjectError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {EmailsubjectError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Start
                              </label>
                              {/* <input type="text" className="form-control " id="exampleInputEmail1" placeholder="Enter QR Code Name here" /> */}
                              <DatePicker
                                className="form-control "
                                dateFormat="dd/MM/yyyy"
                                selected={startDate}
                                onChange={(date) => onChangeStartDate(date)}
                                required
                              />
                            </div>
                            {startDateError?.length > 0 && (
                              <span style={{ color: "red", marginLeft: 6 }}>
                                {startDateError}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                End
                              </label>
                              <DatePicker
                                className="form-control "
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                                selected={endDate}
                                onChange={(date) => onChangeEndDate(date)}
                                required
                              />
                            </div>
                            {EndDateError?.length > 0 && (
                              <span style={{ color: "red", marginLeft: 6 }}>
                                {EndDateError}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Enter Location
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Location"
                                maxLength={100}
                                value={QrcodeLocation}
                                onChange={(e) => {
                                  onchangeLoction(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QrcodeLocation?.length}/100
                              </p>
                              {QrcodeLocationError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QrcodeLocationError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Enter Description
                              </label>

                              {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={description}
                                                                onReady={editor => {
                                                                    // You can store the "editor" and use when it is needed.
                                                                    console.log('Editor is ready to use!', editor);
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    onChangeDescription(data);
                                                                    //console.log({ event, editor, data });
                                                                }}
                                                                onBlur={(event, editor) => {
                                                                    console.log('Blur.', editor);
                                                                }}
                                                                onFocus={(event, editor) => {
                                                                    console.log('Focus.', editor);
                                                                }}
                                                                style={{ height: 200 }}
                                                            /> */}
                              <textarea
                                className="form-control "
                                value={description}
                                maxLength={600}
                                rows="3"
                                placeholder="Enter Description"
                                onChange={onChangeDescription}
                              ></textarea>
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {description?.length}/600
                              </p>
                              {descriptionError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {descriptionError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <div className='row m-b-15'>
                                                    <div className='col-md-12'>
                                                        <div className="checkbox checkbox-css checkbox-inline">
                                                            <input type="checkbox" checked={isstaticwifi_calender} id="CalendarCheckbox" onChange={(e) => { onchangewifi_calenderStaticCheckbox(e) }} />
                                                            <label htmlFor="CalendarCheckbox">Static</label>
                                                        </div>
                                                    </div>

                                                </div> */}

                        {/* <button type="submit" className="btn btn-primary shadow-add m-r-10">Save</button>
                                                <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center">
                            <div className="  bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">Calendar</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElCalendar"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}
                          {/* <img src="../assets/img/user/QR.png" alt='img' style={{ minHeight: '200px', maxHeight: '300px', }}></img> */}
                          <h3>{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("Calendar");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("Calendar");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="Wifi">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i class="fas fa-lg fa-fw m-r-10 fa-wifi text-white"></i>
                            <h5 className="mb-0 text-white">Wi-Fi</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                //autocomplete="off"
                                maxLength={60}
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {QRcodeNameError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                SSID / Network name
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Enter SSID / Networ...."
                                value={Emailsubject}
                                onChange={(e) => {
                                  onchangeEmailSubject(e);
                                }}
                              />
                              {EmailsubjectError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {EmailsubjectError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Password
                              </label>
                              <div className="input-group">
                                {ispasswordshow === false ? (
                                  <>
                                    <input
                                      type="password"
                                      className="form-control "
                                      id="exampleInputEmail1"
                                      placeholder="Password"
                                      value={WifiPassword}
                                      //autocomplete="off"
                                      onChange={(e) => {
                                        onchangeWifiPassword(e);
                                      }}
                                    />
                                    <span class="input-group-text">
                                      <i
                                        class="fas fa-lg fa-fw me-10px fa-eye-slash"
                                        onClick={(e) => {
                                          Onclickpasseordshow();
                                        }}
                                      ></i>
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control "
                                      id="exampleInputEmail1"
                                      placeholder="Password"
                                      value={WifiPassword}
                                      onChange={(e) => {
                                        onchangeWifiPassword(e);
                                      }}
                                    />
                                    <span class="input-group-text">
                                      <i
                                        class="fas fa-lg fa-fw me-10px fa-eye"
                                        onClick={(e) => {
                                          Onclickpasseordshow();
                                        }}
                                      ></i>
                                    </span>
                                  </>
                                )}
                              </div>
                              {WifiPasswordError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {WifiPasswordError}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Select
                              </label>
                              <select
                                className="form-control"
                                value={WifiType}
                                onChange={onChangeWifiType}
                              >
                                <option value="" selected>
                                  --- Select WifiType ---
                                </option>
                                {WifiTypeList.length > 0 ? (
                                  WifiTypeList.map((item) => (
                                    <option
                                      value={item.value}
                                      label={item.text}
                                    >
                                      {item.text}
                                    </option>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </select>
                              {WifiTypeError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {WifiTypeError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                       
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      // onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                      onchangeDynamicCheckbox={()=>{console.log()}}
                      //onchangeStaticCheckbox={()=>{console.log()}}
                      isStaticfixed={true}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center">
                            <div className="  bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">Wi-Fi</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElWifi"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}
                          <h3>{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("Wifi");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("Wifi");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
              <TabPane tabId="MyQR">
                <div className="row">
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="d-flex align-items-center  bg-success btn-sm me-5px mb-2">
                            <i class="fas fa-lg fa-fw m-r-10 fa-qrcode text-white"></i>
                            <h5 className="mb-0 text-white">My QR</h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                QR Code Name :
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter QR Code Name here"
                                value={QRcodeName}
                                //autocomplete="off"
                                maxLength={60}
                                onChange={(e) => {
                                  onchangeQRcodeName(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {QRcodeName?.length}/60
                              </p>
                              {QRcodeNameError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {QRcodeNameError}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Name
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Name"
                                maxLength={60}
                                value={Emailsubject}
                                onChange={(e) => {
                                  onchangeEmailSubject(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {Emailsubject?.length}/60
                              </p>
                              {EmailsubjectError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {EmailsubjectError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <div className='col-md-6'>
                                                            <div className="form-group ">
                                                                <label htmlFor="exampleInputEmail1 " className="">Street</label>
                                                                <input type="text" className="form-control "
                                                                    id="exampleInputEmail1" placeholder="Enter Address"
                                                                    value={MyAddress}
                                                                    maxLength={120}
                                                                    onChange={(e) => { onchangeMyAddress(e) }} />
                                                                <textarea
                                                                    className="form-control "
                                                                    value={MyAddress}
                                                                    maxLength={600}
                                                                    rows="3"
                                                                    placeholder="Enter Address"
                                                                    onChange={(e) => onchangeMyAddress(e)}>
                                                                </textarea>
                                                                <p style={{ textAlign: 'right', fontSize: 12, color: 'red' }}>{MyAddress.length}/600</p>
                                                                {MyAddressError.length > 0 &&
                                                                    <span style={{ color: 'red', marginLeft: 6 }}>{MyAddressError}</span>}
                                                            </div>
                                                        </div> */}
                        <div className="row">
                          <div className="col-md-3 mt-4">
                            <h5>Your Image</h5>
                          </div>
                          <div className="col-xl-2 d-flex align-items-center pb-4">
                            <div className="custom-file file-upload-height">
                              {CompanyLogoPath ? (
                                <button
                                  className="delete-button"
                                  onClick={(e) => {
                                    swal({
                                      title: "Are you sure?",
                                      text: "Once deleted, you will not be able to recover this imaginary file!",
                                      icon: "warning",
                                      buttons: true,
                                      dangerMode: true,
                                    }).then((willDelete) => {
                                      if (willDelete) {
                                        setCompanyLogoPath("");
                                        setCompanyLogo(null);
                                      }
                                    });
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              ) : MyQrcodeLogoPathID ? (
                                <button
                                  className="delete-button"
                                  onClick={(e) => {
                                    deletemyImage(MyQrcodeLogoPathID);
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              ) : (
                                <></>
                              )}

                              {/* <input type="file" onChange={this.onChangeCompanyLogo} className="custom-file-input file-upload-height" id="customFile" /> */}
                              <input
                                type="file"
                                onChange={(e) => CompanysetFile(e)}
                                className="custom-file-input file-upload-height"
                                accept="image/x-png, image/gif, image/jpeg"
                                max-size="2000"
                              />
                              <label
                                className=" profile-upload-1 file-upload-height"
                                for="customFile "
                              >
                                {/* <img src={CompanyLogoPath} className="img-upload-size" /> */}

                                {CompanyLogoPath ? (
                                  <img
                                    src={CompanyLogoPath}
                                    className="img-upload-size m-0"
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src =
                                        "../assets/img/new-images/images.png";
                                    }}
                                  ></img>
                                ) : MyQrcodeLogoPathID ? (
                                  <img
                                    src={MyQrcodeLogoPath}
                                    className="img-upload-size m-0"
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src =
                                        "../assets/img/new-images/images.png";
                                    }}
                                  ></img>
                                ) : (
                                  <img
                                    src={"../assets/img/new-images/images.png"}
                                    className="img-upload-size m-0"
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src =
                                        "../assets/img/new-images/images.png";
                                    }}
                                  ></img>
                                )}
                                <div className="file-upload-3 ">
                                  <i className="ion ion-md-camera  fa-sm"></i>
                                </div>
                              </label>
                            </div>
                            {/* <div className="mt-2">
                                                            <input type="checkbox"
                                                                value="" id="RelatedCheckboxae1"
                                                                // checked={IsPublishedLogo}
                                                                // onChange={(e) => { IsPublishedLogoupdate(e) }} 
                                                                />
                                                            <label htmlFor="RelatedCheckboxae1" className='ml-2'> Publish</label>
                                                        </div> */}
                          </div>
                        </div>
                        <div>
                          {/* <div className='col-md-2'>
                                                        <h5>Address</h5>
                                                    </div> */}
                          <h5>Address</h5>
                          {/* <div className='col-md-10'> */}
                          <div className="row">
                            <div className="col-xxl-6 col-lg-12 col-md-12">
                              <div className="form-group ">
                                <label
                                  htmlFor="exampleInputEmail1 "
                                  className=""
                                >
                                  Street
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="exampleInputEmail1"
                                  placeholder="Enter Street Address"
                                  value={MyStreet}
                                  // maxLength={120}
                                  onChange={(e) => {
                                    onchangeMyStreet(e);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-3 col-lg-6 col-md-12">
                              <div className="form-group ">
                                <label
                                  htmlFor="exampleInputEmail1 "
                                  className=""
                                >
                                  House Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="exampleInputEmail1"
                                  placeholder="Enter House Number"
                                  value={MyHouseNo}
                                  maxLength={15}
                                  onChange={(e) => {
                                    onchangeMyHouseNo(e);
                                  }}
                                />
                                <p
                                  style={{
                                    textAlign: "right",
                                    fontSize: 12,
                                    color: "red",
                                  }}
                                >
                                  {MyHouseNo?.length}/15
                                </p>
                              </div>
                            </div>
                            <div className="col-xxl-3 col-lg-6 col-md-12">
                              <div className="form-group ">
                                <label
                                  htmlFor="exampleInputEmail1 "
                                  className=""
                                >
                                  PLZ / Post Code
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="exampleInputEmail1"
                                  placeholder="Enter PLZ / Post Code"
                                  // maxLength={15}
                                  value={MyPostCode}
                                  maxLength={15}
                                  onChange={(e) => {
                                    onchangeMyPostCode(e);
                                  }}
                                />
                                <p
                                  style={{
                                    textAlign: "right",
                                    fontSize: 12,
                                    color: "red",
                                  }}
                                >
                                  {MyPostCode?.length}/15
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group ">
                                <label
                                  htmlFor="exampleInputEmail1 "
                                  className=""
                                >
                                  City
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="exampleInputEmail1"
                                  placeholder="Enter City"
                                  value={MyCity}
                                  // maxLength={120}
                                  onChange={(e) => {
                                    onchangeMyCity(e);
                                  }}
                                />
                              </div>
                            </div>
                            {/* <div className='col-md-6'>
                                                                <div className="form-group ">
                                                                    <label htmlFor="exampleInputEmail1 " className="">Country</label>
                                                                    <input type="text" className="form-control "
                                                                        id="exampleInputEmail1" placeholder="Enter Country"
                                                                        value={MyCountry}
                                                                        // maxLength={120}
                                                                        onChange={(e) => { onchangeMyCountry(e) }} />
                                                                </div>
                                                            </div> */}
                            <div className="form-group col-md-6 ">
                              <label htmlFor="exampleInputEmail1">
                                Country
                              </label>
                              <select
                                className="default-select2 form-control  input-design"
                                value={MyCountry}
                                onChange={(e) => {
                                  onchangeMyCountry(e);
                                }}
                              >
                                <option value="" label="" selected>
                                  Select Country
                                </option>
                                {CountrydetailList?.length > 0 ? (
                                  CountrydetailList.map((d) => (
                                    <option value={d.value} label={d.text}>
                                      {d.text}
                                    </option>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </select>
                              {/* {MyCountryError.length > 0 ? <span style={{ color: "red", fontSize: '12px', fontWeight: '500', marginLeft: '10px', }}>{MyCountryError}</span> : ''} */}
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Organization
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Organization"
                                value={Organization}
                                maxLength={60}
                                onChange={(e) => {
                                  onchangeOrganization(e);
                                }}
                              />
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {Organization?.length}/60
                              </p>
                              {OrganizationError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {OrganizationError}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Email
                              </label>
                              <input
                                type="email"
                                className="form-control "
                                id="exampleInputEmail1"
                                placeholder="Enter Email"
                                value={MyEmail}
                                onChange={(e) => {
                                  onchangeMyEmail(e);
                                }}
                              />
                              {MyEmailError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {MyEmailError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <div className='col-md-2'> */}
                        {/* <h4>Phone Number</h4> */}
                        {/* </div> */}
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group ">
                              <label htmlFor="exampleInputEmail1 " className="">
                                Phone Number
                              </label>
                              <div className="row">
                                <div className="col-md-6">
                                  <label>Office</label>
                                  <input
                                    type="text"
                                    className="form-control "
                                    id="exampleInputEmail1"
                                    placeholder="Enter Phone Number"
                                    value={OfficePhoneNumber}
                                    //autocomplete="off"
                                    //maxLength={13}
                                    onChange={(e) => {
                                      onchangeOfficePhoneName(e);
                                    }}
                                  />
                                  {OfficePhoneNumberError?.length > 0 && (
                                    <span
                                      style={{ color: "red", marginLeft: 6 }}
                                    >
                                      {OfficePhoneNumberError}
                                    </span>
                                  )}
                                </div>

                                <div className="col-md-6">
                                  <label>Phone</label>
                                  <input
                                    type="text"
                                    className="form-control "
                                    id="exampleInputEmail1"
                                    placeholder="Enter Phone Number"
                                    value={PhoneNumber}
                                    //autocomplete="off"
                                    maxLength={13}
                                    onChange={(e) => {
                                      onchangePhoneName(e);
                                    }}
                                  />
                                  {PhoneNumberError?.length > 0 && (
                                    <span
                                      style={{ color: "red", marginLeft: 6 }}
                                    >
                                      {PhoneNumberError}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className='col-md-6'>
                                                        <div className="form-group ">
                                                            <label htmlFor="exampleInputEmail1 " className="">Mobail</label>
                                                            <input type="text" className="form-control " id="exampleInputEmail1"
                                                                placeholder="Enter Phone Number"
                                                                value={PhoneNumber}
                                                                //autocomplete="off"
                                                                maxLength={10}
                                                                onChange={(e) => { onchangePhoneName(e) }} />
                                                            {PhoneNumberError.length > 0 &&
                                                                <span style={{ color: 'red', marginLeft: 6 }}>{PhoneNumberError}</span>}
                                                        </div>
                                                    </div> */}
                        </div>
                        {/* </div> */}
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="col-form-label ">Notes</label>
                              {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={description}
                                                                onReady={editor => {
                                                                    // You can store the "editor" and use when it is needed.
                                                                    console.log('Editor is ready to use!', editor);
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    onChangeDescription(data);
                                                                    //console.log({ event, editor, data });
                                                                }}
                                                                onBlur={(event, editor) => {
                                                                    console.log('Blur.', editor);
                                                                }}
                                                                onFocus={(event, editor) => {
                                                                    console.log('Focus.', editor);
                                                                }}
                                                                style={{ height: 200 }}
                                                            /> */}
                              <textarea
                                className="form-control "
                                value={description}
                                maxLength={600}
                                rows="3"
                                placeholder="Enter Notes"
                                onChange={onChangeDescription}
                              ></textarea>
                              <p
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                {description?.length}/600
                              </p>
                              {descriptionError?.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                  {descriptionError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <Panel className="border" theme="success">
                          <PanelHeader>
                            <h4 className="mb-0 text-light">
                              External web site link
                            </h4>
                          </PanelHeader>
                          <PanelBody>
                            <div className="row">
                              <div className="col-xl-12">
                                <div className="form-group ">
                                  <label className=" col-form-label">
                                    Name
                                  </label>
                                  {/* <div className="col-md-6"> */}
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your link name"
                                    maxLength={30}
                                    value={websitelinkname}
                                    onChange={onChangewebsitelinkname}
                                  />
                                  <p
                                    style={{
                                      textAlign: "right",
                                      fontSize: 12,
                                      color: "red",
                                    }}
                                  >
                                    {websitelinkname?.length}/30
                                  </p>
                                  {/* </div> */}
                                </div>
                              </div>
                              <div className="col-xl-12">
                                <div className="form-group ">
                                  <label className="col-form-label">
                                    Enter website link
                                  </label>
                                  <div className=" row align-items-center">
                                    <div className="col-md-10">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter website link"
                                        value={webLink}
                                        onChange={onChangeWebLink}
                                      />
                                      {WebLinkError?.length > 0 && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: 6,
                                          }}
                                        >
                                          {WebLinkError}
                                        </span>
                                      )}
                                    </div>
                                    <div className="col-md-2">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          CreateExternalLink();
                                        }}
                                        className="btn btn-primary shadow-add  my-2"
                                      >
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </PanelBody>
                        </Panel>
                        {/* <div className='container-fluid'> */}
                        <div className="row ">
                          <div className="col-lg-12 ">
                            <div className="table-responsive">
                              {articleSegmentWebLinkList?.length > 0 ? (
                                <table
                                  id="data-table-buttons"
                                  className="table table-striped table-bordered table-td-valign-middle "
                                >
                                  <thead>
                                    <tr className="odd gradeA">
                                      <th className="text-nowrap ">Name</th>
                                      <th className="text-nowrap ">WebLink</th>

                                      <th
                                        className="text-nowrap text-center"
                                        style={{ width: "15%" }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  {articleSegmentWebLinkList !== null ? (
                                    <tbody>
                                      {articleSegmentWebLinkList.map(
                                        (subscriber, index) => (
                                          <tr>
                                            <td>
                                              <p className="mb-0 breakword">
                                                {subscriber.name}
                                              </p>
                                            </td>
                                            <td>
                                              <p className="mb-0 breakword">
                                                {subscriber.linkURL}
                                              </p>
                                            </td>

                                            <td className="text-center">
                                              <a
                                                href="javascript:void(0)"
                                                className="btn btn-danger"
                                                onClick={() => {
                                                  ArticleWeblinkdelete(index);
                                                }}
                                              >
                                                <i className="fas fa-trash"></i>
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  ) : null}
                                </table>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        {/* <button type="submit" className="btn btn-primary shadow-add m-r-10">Save</button>
                                                <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
                      </PanelBody>
                    </Panel>
                    <PersonalCategorysection
                      subcategoryId={subcategoryId}
                      subcategoryIdError={subcategoryIdError}
                      CategoryId={CategoryId}
                      CategoryIdError={CategoryIdError}
                      // toggle3={toggle3}
                      toggle3={async (e) => {
                        try {
                          let response =
                            await CheckQRCodeCategoriesManagementEnabled();
                          if (response === true || response === "true") {
                            toggle3();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your qrcode categories management enabled.",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                      CategoryList={CategoryList}
                      subcetgoryList={subcetgoryList}
                      onChangeCategory={onChangeCategory}
                      onChangeSubCategory={onChangeSubCategory}
                      Static={Static}
                      Dynamic={Dynamic}
                      onchangeDynamicCheckbox={onchangeDynamicCheckbox}
                      onchangeStaticCheckbox={onchangeStaticCheckbox}
                    />
                  </div>
                  <div className="col-xl-6">
                    <Panel className="bg-grey">
                      <PanelHeader>
                        <h4 className="mb-0 text-white">QR code</h4>
                      </PanelHeader>
                      <PanelBody>
                        <div className=" text-center">
                          <div className="row  justify-content-center mb-4">
                            <div className="  bg-success btn-sm me-5px mb-2">
                              <h3 className="mb-0 text-white">My QR</h3>
                            </div>
                          </div>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <QRCode
                              value={QrCodeString}
                              id="qrCodeElMyQR"
                              className="qrcode-responsive"
                            />
                          ) : (
                            <img
                              src="/assets/img/new-Images/qr-code-scanner.jpg"
                              className="respnsive-imag"
                            ></img>
                          )}

                          {/* <img src="../assets/img/user/QR.png" alt='img' style={{ minHeight: '200px', maxHeight: '300px', }}></img> */}
                          <h3 className="mt-3">{FinalQRcodeName}</h3>
                          {QrCodeString != null &&
                            QrCodeString != undefined &&
                            QrCodeString != "" ? (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                                onClick={() => {
                                  printQrcode("MyQR");
                                }}
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                                onClick={() => {
                                  downloadQRCodeArticle("MyQR");
                                }}
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                                onClick={() => {
                                  toggleToEmail();
                                }}
                              >
                                Send{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center mt-4">
                              <button
                                type="submit"
                                className="btn btn-warning  m-r-5 m-b-5"
                              >
                                Print
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-b-5 m-r-5"
                              >
                                Download
                              </button>
                              <button
                                type="submit"
                                className="btn btn-warning m-r-5 m-b-5"
                              >
                                Send{" "}
                              </button>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </div>
                  <button
                    type="submit"
                    // onClick={(e) => {
                    //   UpdateQRCode();
                    // }}
                    onClick={async (e) => {
                      // UpdateQRCode();
                      try {
                        if (Dynamic === true || Dynamic === "true") {
                          if (PersonalData?.isCategoryStatic === true) {
                            let response =
                              await CheckDynamicPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Dynamic Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        } else {
                          if (PersonalData?.isCategoryStatic === false) {
                            let response =
                              await CheckStaticPersonalQRcodecount();
                            if (response === true || response === "true") {
                              UpdateQRCode();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Static Personal QR Code .",
                                "warning"
                              );
                            }
                          } else {
                            UpdateQRCode();
                          }
                        }
                      } catch (error) {
                        console.log("error!", error);
                      }
                    }}
                    className="btn btn-big-lg btn-danger shadow-add mt-2"
                  >
                    <h5 className="mb-0 text-white">Update QR Code</h5>
                  </button>
                </div>
              </TabPane>
            </TabContent>
          </PanelBody>
        </Panel>
      </div>
      <Modal isOpen={modal3} toggle={toggle3}>
        <ModalHeader toggle={toggle3} className="modalheader">
          <h5 className="text-white">Add Category</h5>
        </ModalHeader>
        <ModalBody>
          <form action="" method="POST" className="m-b-30">
            <div className="form-group container-fluid">
              <label htmlFor="exampleInputEmail1">Main Category</label>
              <div className="input-group row">
                <input
                  type="text"
                  maxLength={30}
                  className="form-control col-sm-8"
                  placeholder="Please Enter Main Category"
                  value={MainCategory}
                  onChange={(e) => {
                    onChangeMaincategory(e);
                  }}
                />
                <p
                  className="col-sm-1"
                  style={{ textAlign: "right", fontSize: 12, color: "red" }}
                >
                  {MainCategory.length}/30
                </p>
                {MainCategoryError?.length > 0 && (
                  <span
                    className="col-sm-12"
                    style={{ color: "red", marginLeft: 6 }}
                  >
                    {MainCategoryError}
                  </span>
                )}
                {/* <button type="button" className="btn btn-sm btn-danger shadow-add m-l-10 col-sm-1" onClick={(e) => { SubCategoryaddClick(e) }}><i className="fas fa-lg fa-fw  fa-trash-alt"></i></button> */}
              </div>
            </div>
            <div className="form-group container-fluid">
              <label htmlFor="exampleInputPassword1">
                Sub Category
                {/* <a href="#" className="m-l-10"><i className="fas fa-lg fa-fw m-r-10 fa-plus-circle"></i></a> */}
                <button
                  type="button"
                  className="m-l-10 btn btn-link"
                  onClick={(e) => {
                    SubCategoryaddClick(e);
                  }}
                >
                  <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                </button>
              </label>
              <div className="input-group row justify-content-center m-b-10">
                <div className="" style={{ width: "100%" }}>
                  {createSubCategoryUI()}
                </div>
                {/* <button type="button" className="btn btn-sm btn-danger shadow-add m-l-10 col-sm-1"><i className="fas fa-lg fa-fw  fa-trash-alt"></i></button> */}
              </div>
              {isSubcategoryMaltiple === true ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {"Sub Category name dublicate"}
                </span>
              ) : (
                ""
              )}
              {SubCategoryAddtimeError?.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {SubCategoryAddtimeError}
                </span>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={() => {
                  createCategory();
                }}
                className="btn btn-sm btn-primary m-r-5 shadow-add "
              >
                Create
              </button>
              <button
                type="button"
                onClick={() => {
                  toggle3();
                }}
                className="btn btn-sm btn-danger shadow-add "
              >
                Cancel
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <Modal isOpen={isToEamil} toggle={toggleToEmail}>
        <ModalHeader toggle={toggleToEmail} className="modalheader">
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError?.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodePersonalSend();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmail();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default EditQRCode;
